<template>
  <div class="wrapper">
  <header :class="headerComponent">
    <component :is="headerComponent" />
  </header>
  </div>
</template>

<script>
import ScenarioHeader from '@/components/trainee/ScenarioHeader.vue'
import PageHeader from '@/components/PageHeader.vue'
export default {
  name: "AppHeader",
  components: {
    ScenarioHeader,
    PageHeader
  },
  data () {
    return {
    }
  },
  mounted () {},
  methods: {},
  computed: {
    title () {
      return this.$store.state.headerTitle
    },
    headerComponent () {
      return this.$store.state.headerComponent
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100vw;
  overflow-x: hidden;
}

header {
  // grid-area: sheader;
  position: relative;
  background-color: #3d3dde;
  // min-height: 240px;
  max-width: calc(100vw - 15px);
  margin: 0 auto 24px 0;
  border-radius: 0 0 80px 0;

  // .inner-header {
    transition: height .2s cubic-bezier(0.22, 0.61, 0.36, 1) 0s;
  // }

  &.ScenarioHeader {
    height: 230px;
  }
  &.PageHeader {
    height: 165px;
  }
  

  @media all and (min-width: 1430px) {
    max-width: var(--container-width);
    margin: 0 auto 24px;
    border-radius: 0;

    &::before {
      content: " ";
      height: 100%;
      background-color: inherit;
      position: absolute;
      right: 100%;
      top: 0;
      width: 100vw;
    }
    &::after {
      content: " ";
      height: 100%;
      background-color: inherit;
      position: absolute;
      left: 100%;
      top: 0;
      width: 250px;
      border-radius: 0 0 240px 0;
    }
  }
}

header /deep/ h1 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

</style>